//#region src/location_payment_type.ts
var LocationPaymentType = /* @__PURE__ */ function(LocationPaymentType) {
	LocationPaymentType[LocationPaymentType["CashierOnly"] = 0] = "CashierOnly";
	LocationPaymentType[LocationPaymentType["CreditCard"] = 1] = "CreditCard";
	return LocationPaymentType;
}(LocationPaymentType || {});
//#endregion
export { LocationPaymentType };

//# sourceMappingURL=location_payment_type.js.map